module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-wrapper",
    class: {
      'landing': _vm.isLanding, 'affix': _vm.isAffix
    }
  }, [_c('nav', {
    staticClass: "container navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item navbar-header",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    style: ({
      maxHeight: 'auto',
      marginRight: '30px'
    }),
    attrs: {
      "src": require("../assets/logo.svg"),
      "width": "110"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Lasting Impressions")])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger burger",
    class: _vm.showNav ? 'is-active' : 'undefined',
    attrs: {
      "data-target": "nav-menu"
    },
    on: {
      "click": function($event) {
        _vm.showNav = !_vm.showNav
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    class: _vm.showNav ? 'is-active' : 'undefined',
    attrs: {
      "id": "nav-menu"
    }
  }, [_c('div', {
    staticClass: "navbar-start"
  }), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    class: {
      active: _vm.$route.name === 'about'
    },
    attrs: {
      "href": "#",
      "to": "about"
    }
  }, [_vm._v("\n          About\n        ")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50701bfb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = 743
// module chunks = 1